import React from "react"
export default function DownArrow(props) {
  const color = props.color || "#fff"
  return (
    <svg
      id="arrow--down-right"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <path
        id="Path_29723"
        data-name="Path 29723"
        d="M10,26V24H22.59L6,7.41,7.41,6,24,22.59V10h2V26Z"
        fill={color}
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="32"
        height="32"
        fill="none"
      />
    </svg>
  )
}
